<template>
  <div class="vx-card__header row">
    <div class="col-12 col-md-6">
      <h4 class="text-primary">Parámetros</h4>
    </div>
    <div
      class="col-12 col-md-2"
      v-has-permission="'FEB99'"
    >
      <select
        type="select"
        class="form-control"
        :value="application"
        @change="$emit('update:application', $event.target.value)"
      >
        <option
          v-for="app in applications"
          :key="app.id"
          :value="app.id"
        >
          {{ app.description }}
        </option>
      </select>
    </div>
    <div
      class="col-12 col-md-4"
      v-has-permission="'FEB99'"
    >
      <ListUser
        id="user"
        name="user"
        label=""
        placeholder="Seleccione un usuario..."
        :value="selectedUserId"
        @input="$emit('update:selectedUserId', $event)"
      />
    </div>
  </div>
</template>

<script>
import { applications } from '@/febos/global/utils/configurations';
import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  name: 'ConfigParamsHeader',
  components: { ListUser },
  props: {
    application: {
      type: String,
      required: true
    },
    selectedUserId: {
      type: String,
      default: ''
    },
    isSuperAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      applications
    };
  }
};
</script>
